import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PatchShipmentRequest } from 'app/generated/backend/shipment/api/patch-shipment-request';
import { ShipmentDetailModel } from 'app/generated/backend/shipment/api/shipment-detail-model';

@Injectable()
export class ShipmentDetailHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		number: string
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.get<JsonResourceResponse<ShipmentDetailModel>>(`api/v1/shipment/shipments/detail/${number}`).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	patch(
		number: string,
		request: PatchShipmentRequest
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.patch<JsonResourceResponse<ShipmentDetailModel>>(`api/v1/shipment/shipments/detail/${number}`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ShipmentDetailHandlerService
	]
})
export class ShipmentDetailHandlerModule { }
